<template>
  <div class="c-media-video">
    <div class="embed-container" v-if="platform === 'youtube' && youtubeVideoId">
      <!-- Youtube -->
      <iframe
        width="560"
        height="315"
        :src="youtubeEmbedSrc"
        frameborder="0"
        allow="autoplay; encrypted-media"
        allowfullscreen
      ></iframe>
    </div>

    <div class="embed-container" v-if="platform === 'vimeo' && vimeoVideoId">
      <!-- Vimeo -->
      <iframe
        :src="vimeoEmbedSrc"
        frameborder="0"
        webkitAllowFullScreen
        mozallowfullscreen
        allowfullscreen
      ></iframe>
    </div>

    <div class="c-media-video__caption" v-if="caption">{{caption}}</div>
  </div>
</template>

<script>
export default {
  name: 'media-video',

  props: {
    videoLink: String,
    caption: String,
  },

  data() {
    return {
      //
    };
  },

  computed: {
    youtubeEmbedSrc() {
      if (this.platform === 'youtube' && this.youtubeVideoId) {
        return (
          `https://www.youtube-nocookie.com/embed/${
            this.youtubeVideoId
          }?modestbranding=1` +
          'amp;rel=0' +
          'amp;showinfo=0'
        );
      }
    },

    vimeoEmbedSrc() {
      if (this.platform === 'vimeo' && this.vimeoVideoId) {
        return `https://player.vimeo.com/video/${this.vimeoVideoId}`;
      }
    },

    vimeoVideoId() {
      if (this.platform === 'vimeo') {
        const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
        const match = this.videoLink.match(regExp);
        return match[5];
      }
      return false;
    },

    youtubeVideoId() {
      if (this.platform === 'youtube') {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        const match = this.videoLink.match(regExp);
        return match && match[7].length == 11 ? match[7] : false;
      }

      return false;
    },

    platform() {
      let platform = '';
      const { videoLink } = this;

      if (videoLink && videoLink.indexOf('youtu') !== -1) {
        platform = 'youtube';
      }
      if (videoLink && videoLink.indexOf('vimeo') !== -1) {
        platform = 'vimeo';
      }

      return platform;
    },
  },
};
</script>

<style lang="scss">
.c-media-video {
  margin: 2.5em 0;
  background: $colour-nhs-pale-grey;

  &__caption {
    padding: 1em;
    color: #202020;
    font-size: 16px;
  }
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
